import { useState } from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { useAppKit } from "@reown/appkit/react";
import {
  C,
  DeliveryAddressDialog,
  IncomeHistoryDialog,
  TransferDialog,
} from "@/components/modal/home";
import { MyAgentsSectionBody } from "@/components/home/MyAgentsSection";
import { useGetMyFortAgents } from "@/hooks/api/useGetMyFortAgents";
import { useUserStore } from "@/store/useUserStore";
import { MyFortAgentItem } from "@/api/types";

export default function MyAgents() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { open: openAppKit } = useAppKit();
  const { userInfo } = useUserStore();
  const { data: myAgents, isLoading: myAgentsLoading } = useGetMyFortAgents();

  const [addressOpen, setAddressOpen] = useState(false);
  const [transferOpen, setTransferOpen] = useState(false);
  const [transferAgent, setTransferAgent] = useState<MyFortAgentItem | null>(
    null
  );
  const [incomeHistoryOpen, setIncomeHistoryOpen] = useState(false);

  const count = myAgents?.agents?.length ?? 0;

  return (
    <div className="pt-top-header-relaxed pb-24 px-4 max-w-lg mx-auto page-enter">
      <div className="flex items-center gap-3 mb-4">
        <button
          type="button"
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg transition-all hover:opacity-80"
          style={{
            background: "rgba(255,255,255,0.04)",
            border: `1px solid ${C.border}`,
            color: C.muted,
          }}
          onClick={() => navigate(-1)}
          aria-label={t("topHeader.backToHome")}
        >
          <ArrowLeft size={18} />
        </button>
        <div className="min-w-0 flex-1 flex items-center gap-2">
          <h1 className="font-bold text-lg truncate">
            {t("homePage.myAgents.title")}
          </h1>
          {userInfo?.address && count > 0 && (
            <span
              className="text-[10px] px-1.5 py-0.5 rounded-full font-bold shrink-0"
              style={{ background: `${C.primary}15`, color: C.primary }}
            >
              {t("homePage.myAgents.ownedCount", { count })}
            </span>
          )}
        </div>
      </div>

      <MyAgentsSectionBody
        myAgentsLoading={myAgentsLoading}
        agents={myAgents?.agents}
        onAddress={() => setAddressOpen(true)}
        onTransfer={agent => {
          setTransferAgent(agent);
          setTransferOpen(true);
        }}
      />

      <DeliveryAddressDialog
        open={addressOpen}
        onClose={() => setAddressOpen(false)}
      />
      {transferAgent != null && (
        <TransferDialog
          open={transferOpen}
          onClose={() => {
            setTransferOpen(false);
            setTransferAgent(null);
          }}
          agent={transferAgent}
        />
      )}
      <IncomeHistoryDialog
        open={incomeHistoryOpen}
        onClose={() => setIncomeHistoryOpen(false)}
      />
    </div>
  );
}
